module.exports = __webpack_public_path__ + "fa0d83a0.svg";